<template>
  <van-popup position="top" v-model="show">
    <div v-if="show" class="topnavbox" @click="topnavPlay">
      <van-cell-group class="topnav">
        <router-link to="/" tag="div" class="van-cell van-hairline"><span><i class="van-icon iconfont icon-shouye1"></i>首页</span></router-link>
        <router-link to="/goodstype" tag="div" class="van-cell van-hairline"><span><i class="van-icon iconfont icon-fenlei1"></i>分类</span></router-link>
        <router-link to="/user/cart" tag="div" class="van-cell van-hairline"><span><i class="van-icon iconfont icon-gouwuche"></i>兑换袋</span></router-link>
        <router-link to="/user" tag="div" class="van-cell van-hairline"><span><i class="van-icon iconfont icon-yonghuming"></i>我的</span></router-link>
      </van-cell-group>
    </div>
  </van-popup>
</template>

<script>
  export default {
    name: "topnav",
    data() {
      return {
        show: false
      }
    },
    methods:{
      topnavPlay:function () {
        this.show = !this.show
      }
    }
  }
</script>

<style lang="less" scoped>
  .van-popup{
    overflow: inherit;
  }
.topnavbox{
  position: fixed;
  top: 46px;
  right: 5px;
  [class*=van-hairline]::before{
    height: 0;
    width: 0;
  }
  .topnav{
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    .van-cell{
      padding: 7px 30px;
    }
    .van-cell:not(:last-child)::after{
      right: 15px;
    }
    .van-icon{
      vertical-align: middle;
      font-size: 1.8rem;
      margin-right: 15px;
    }
  }
}
.topnavbox::before{
  content: '';
  position: absolute;
  background: #fff;
  width: 20px;
  height: 20px;
  right: 15px;
  top: -10px;
  z-index: 1;
  transform:rotate(45deg);
}
  .van-cell:not(:last-child)::after {
    bottom: -15px;
  }

</style>



// WEBPACK FOOTER //
// src/components/topnav.vue